module.exports = __webpack_public_path__ + "img/today_text.0b7f540d.svg";